import React from 'react';
import { Link } from 'react-router-dom';
import { CheckIcon, ArrowRightIcon } from 'lucide-react';
import { Bloom } from './Bloom';
import { ConsolidationVisual } from './visuals/ConsolidationVisual';
import { packageIncludes } from '../data/site';

/* 2026-09-15 (Kevin, three-services restructure, locked): price changed
   from $1,197/mo to $897/mo. $1,197 must not appear anywhere on the site
   from this point on -- do not reinstate it here or anywhere else. Section
   id changed from "pricing" to "viridia-system" so the nav's "Pricing for
   The Viridia System" link and the /pricing three-column strip's button
   both land the buyer on this card specifically, not the top of the page.
   2026-09-17 (Kevin): "The Viridia Package is $897 no setup fee." Added to
   the card line, because every competing answering service and CRM charges
   an onboarding or setup fee and this is the only place a buyer compares
   total first-month cost. Do not add a setup or onboarding charge here. */
export function Pricing() {
  return <section id="viridia-system" className="relative isolate overflow-hidden border-b border-[#1a1a1a]" data-id="element-633" data-mp="3vyx96505i8ho">
      <Bloom size="lg" className="left-1/2 top-[-16rem] -translate-x-1/2" data-id="element-634" data-mp="4v8lip4pqhgh" />

      <div className="mx-auto w-full max-w-3xl px-6 py-20 lg:py-28" data-id="element-635" data-mp="9srxtjhuok5s">
        <p className="text-center font-mono text-xs uppercase tracking-[0.2em] text-neutral-600" data-id="element-636" data-mp="erlgdqbzv1ct">
          What it replaces
        </p>
        <div className="mt-8" data-id="element-637" data-mp="3dasc1ge01lru">
          <ConsolidationVisual data-id="element-638" data-mp="3i81ziqhtvnd1" />
        </div>

        <article className="mt-14 rounded-3xl border border-emerald-500/40 bg-[#0e1310] p-8 text-center sm:p-12" data-id="element-639" data-mp="3i8tvi2fc7n3u">
          <h2 className="font-mono text-xs uppercase tracking-[0.2em] text-emerald-500" data-id="element-640" data-mp="3n5u0ea0gajtd">
            The Viridia System
          </h2>

          <p className="mt-8 flex items-baseline justify-center gap-2" data-id="element-641" data-mp="2uihcnwik05yh">
            <span className="text-5xl font-bold tracking-tight text-white sm:text-6xl" data-id="element-642" data-mp="2ugdbvnfybn2f">
              $897
            </span>
            <span className="text-base text-neutral-500" data-id="element-643" data-mp="2rguxx8i4nmb3">/month</span>
          </p>
          <p className="mt-4 text-sm text-neutral-400" data-id="element-644" data-mp="2rei8kaa1i9o0">
            Month to month. No contracts. No setup fee. We believe in earning it.
          </p>

          <ul className="mx-auto mt-10 grid max-w-xl grid-cols-1 gap-3.5 border-t border-[#1c2420] pt-10 text-left sm:grid-cols-2" data-id="element-645" data-mp="315mopdbgc0kf">
            {packageIncludes.map(item => <li key={item} className="flex gap-2.5 text-sm leading-snug text-neutral-300" data-id="element-646" data-mp="28hh2sn8nw5j0">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-emerald-500" aria-hidden="true" data-id="element-647" data-mp="23jfjc17bq470" />
                {item}
              </li>)}
          </ul>

          <Link to="/contact" className="mt-10 inline-flex items-center gap-2 rounded-full bg-emerald-500 px-7 py-3.5 text-sm font-semibold text-[#0a0a0a] transition-colors hover:bg-emerald-400" data-id="element-648" data-mp="2dg21gi89mh5c">
            Book a 15-min call
            <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-649" data-mp="anbqg8144pr" />
          </Link>
        </article>

        <div className="mt-8 rounded-2xl border border-[#1c1c1c] bg-[#0d0d0d] p-7" data-id="element-650" data-mp="5970sphx5wmc">
          <h3 className="font-mono text-xs uppercase tracking-[0.18em] text-neutral-500" data-id="element-651" data-mp="3nf36etg941wg">
            Already running Yelp ads?
          </h3>
          <p className="mt-4 text-sm leading-relaxed text-neutral-400" data-id="element-652" data-mp="3rhq1d387y2xv">
            Yelp Ads Management is its own service, run by a former Yelp rep, priced against
            your ad spend.
          </p>
          <Link to="/yelp-ads" className="group mt-5 inline-flex items-center gap-2 text-sm font-semibold text-emerald-500 hover:text-emerald-400" data-id="element-653" data-mp="nyn1bctltp2r">
            See Yelp Ads Management
            <ArrowRightIcon className="h-4 w-4 transition-transform group-hover:translate-x-0.5" aria-hidden="true" data-id="element-654" data-mp="e8bxrrdu1hwe" />
          </Link>
        </div>
      </div>
    </section>;
}